import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";
import type I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse";
import type { I_SafetyEventLabel } from "../interfaces";

const patchSafetyEventLabels = async (
  id: number,
  labels: I_SafetyEventLabel[]
): Promise<boolean> => {
  try {
    const config = AxiosConfig.configValue()
    const response = await Axios.patch<I_BaseAPIResponse<null>>(
      `${process.env.REACT_APP_API_URL}/api/samsara/safety-event/${id}/labels`,
      { labels },
      { headers: { ...config.headers, "content-type": "application/json" } }
    );

    if (response.data.HasError) {
      console.error("API Error:", response.data.ErrorMessage);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Network or parsing error:", error);
    return false;
  }
};

export default patchSafetyEventLabels;
